export const Status = {
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    APPROVED: 'Approved'
}